/* eslint-disable unicorn/prevent-abbreviations */
/* eslint-disable @angular-eslint/directive-class-suffix */
/* eslint-disable @angular-eslint/directive-selector */
import { CdkCellDef } from '@angular/cdk/table';
import { Directive, input } from '@angular/core';
import { MatCellDef, MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';

@Directive({
  selector: '[matCellDef]',
  standalone: true,
  providers: [{ provide: CdkCellDef, useExisting: TypeSafeMatCellDeferred }],
})
export class TypeSafeMatCellDeferred<T> extends MatCellDef {
  readonly matCellDefDataSource = input.required<T[] | Observable<T[]> | MatTableDataSource<T>>();

  static ngTemplateContextGuard<T>(dir: TypeSafeMatCellDeferred<T>, context: unknown): context is { $implicit: T; index: number } {
    return true;
  }
}
